import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import aegis from "../images/aegis.png";
import caster from "../images/caster.png";
import ccore from "../images/ccore.png";
import fiq from "../images/fiq.png";
import search from "../images/search.png";
import artc from "../images/artc.png";
import alphago from "../images/alphago.png";
import score from "../images/score.png";
import emma from "../images/emma.png";
import ernie from "../images/ernie.png";
import cps from "../images/cps.png";
import blue_prism from "../images/blue_prism.png";
import aware from "../images/aware.png";
import griffeye from "../images/griffeye.png";
import pha from "../images/pha.png";
import ccl from "../images/ccl.png";
import thermal from "../images/thermal.jpg";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h5>{`AI System Descriptions`}</h5>
    <p>{`Respondents were randomly assigned to use one of the
frameworks to classify three to five AI systems from the following
example systems. Note that some system names were altered or
created for purposes of the survey and may not reflect actual
system names. `}</p>
    <p>{`Systems included in both rounds (Frameworks A,
B, C, and D) were: `}</p>
    <div className="system-container">
      <div className="system-image-container">
    <img src={aegis} className="system-image" alt="Decorative image related to Aegis" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Aegis`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`1`}</a></sup>{`: Aegis Ballistic Missile Defense is a system that uses
radar to detect incoming intermediate-range ballistic
missiles from marine vessels. If detected, the system
transmits target-detection information to interceptors and
fires them at incoming missiles. The system makes a
decision based on the information it perceives and transfers
the decision to military warships, enabling them to
automatically disarm missiles.  `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={caster} className="system-image" alt="Decorative image related to Caster" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Caster`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`2`}</a></sup>{`: Caster is a system that reviews inputted molecular
information of drugs for medical research purposes. The
system is trained to recognize possible drug interactions
and then models organic chemical reactions to predict drug-to-drug interactions, including potential harmful
interactions. Scientists evaluate the model's output to
determine the potential for adverse drug reactions.  `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={ccore} className="system-image" alt="Decorative image related to C-CORE" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`C-CORE`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`3`}</a></sup>{`: C-CORE is a system that scans satellite imagery
over ocean areas to locate marine environmental structures
(e.g., icebergs). The system processes satellite imagery to
identify structures or objects. The system determines object
type, position, and size of identified structures and
automatically enters that information into a marine safety
database. The dataset is used by officials to evaluate marine
safety, including transportation and shipping routes. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={fiq} className="system-image" alt="Decorative image related to FIQ" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Facial Image Quality (FIQ)`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`4`}</a></sup>{`: Facial Image Quality is a tool for
determining the quality of a digital face image. The system
reviews a digital face image and produces a face image
quality score. The score is used by developers of facial
recognition technologies to help determine the reliability of
a face image collected through facial recognition
technology. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={search} className="system-image" alt="Decorative image related to SRD" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Search and Rescue Detection (SRD)`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`5`}</a></sup>{`: Search and Rescue
Detection is an aircraft-based system that scans full motion
video to augment human detection of marine vessels in
distress and persons in the water. The system provides a
display that identifies possible vessels or persons in the
water for the aircraft crew. The system uses human and
sensory inputs to flag the presence of objects or persons
that fit defined criteria for being in distress. The identified
information is shared in real-time with human operators to
determine the need for emergency response. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={artc} className="system-image" alt="Decorative image related to ARTCC" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Air Route Traffic Control Center (ARTCC)`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`6`}</a></sup>{` (included as a non-AI
system in A, B, and C): An ARTCC is a system set up to
oversee and manage air traffic within a controlled zone.
Radar technology provides human operators with flight
path and aircraft information for aircraft flying in the zone's
airspace. The human operators monitor the radar and flight
information in order to assist aircraft pilots. `}</p>
      </div>
    </div>
    <p>{`Two systems were added only in our round two distribution
(Frameworks B, C, and D): `}</p>
    <div className="system-container">
      <div className="system-image-container">
    <img src={alphago} className="system-image" alt="Decorative image related to AlphaGo" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`AlphaGo Zero (AGZ)`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`7`}</a></sup>{`: AlphaGo Zero is a system that plays the
board game Go better than professional human players. The
board game's environment is virtual and player positions
are constrained by the rules of the game. AlphaGo Zero
uses both human-based inputs, including the rules of Go,
and machine-based inputs, primarily data learned through
repeated play against itself. It abstracts data into a model of
actions, or moves, through reinforcement learning. It then
uses the model to make its next move based on the current
state of play. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={score} className="system-image" alt="Decorative image related to SCORE" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`SCORE credit scoring`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`8`}</a></sup>{`: SCORE is a system that makes credit
score recommendations to help gauge a loan applicant's
credit-worthiness. It does so by using human-based inputs
(e.g., a set of rules) and data inputs (e.g., loan payments
histories) to assess whether applicants are repaying loans
on a regular basis. It automatically aggregates inputs and
uses a scoring algorithm to formulate a credit score and
recommendation of options for providing or denying a loan.
The resulting score and recommendation are reviewed by a
human who decides whether to grant or deny a loan.`}</p>
      </div>
    </div> 
    <p>{`Eight systems were included in our round one distribution (for a
total of 15 systems tested using Framework A) but removed for
subsequent distributions: `}</p>
    <div className="system-container">
      <div className="system-image-container">
    <img src={emma} className="system-image" alt="Decorative image related to EMMA" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`EMMA`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`9`}</a></sup>{`: EMMA is a system that provides virtual assistance
with website navigation. The system understands a wide
range of questions and provides immediate answers in
written or spoken format. The system can also help users
search websites and direct them to the most relevant
pages. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={ernie} className="system-image" alt="Decorative image related to ERNIE" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`ERNIE`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`10`}</a></sup>{`: ERNIE is a system that monitors port vehicle traffic
for radiological material and radionuclear threats. The
system reviews radiological and motion sensor data,
classifies the data as alarm or no alarm, and determines
whether to release cargo or hold for further inspection. The
system notifies officers in the case of hold for further
inspection. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={cps} className="system-image" alt="Decorative image related to CPSS" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Checkpoint Property Screening (CPSS)`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`11`}</a></sup>{`: The Checkpoint Property
Screening System checks luggage for non-explosive threat
items such as knives or guns. The system reads a 3D image
of screened luggage and classifies items into the following
categories: weapons, sharps, blunts, or benign. If the system
predicts the presence of a threat item it alerts an officer to
search the bag. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={blue_prism} className="system-image" alt="Decorative image related to Blue Prism" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Blue Prism`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`12`}</a></sup>{`: Blue Prism is a system that reviews and audits
National Flood Insurance Program claims applications. The
system reviews claims and provides a recommendation of
approve, deny, or flag for review. Given preset rules and
constraints, the system helps determine which claims fall
outside preset qualifications. The system includes a front-facing platform for human claims reviewers to assess
claimant information and review system-generated
recommendations. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={aware} className="system-image" alt="Decorative image related to AWARE" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Cyber Network Vulnerability Assessment (AWARE)`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`13`}</a></sup>{`: AWARE is a
system that evaluates cyber inventory and assets to identify
vulnerabilities. It produces a report with visualizations and
recommendations of the vulnerabilities that are most likely
to be exploited in a cyber incident. Reports are used by
administrators to help decide which vulnerabilities to
prioritize. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={griffeye} className="system-image" alt="Decorative image related to Griffeye Brain" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Griffeye Brain`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`14`}</a></sup>{`: Griffeye Brain is a system that scans media
seized by law enforcement for the presence of child
exploitation images or videos. The system classifies images
and videos to alert officials of potential child exploitation
material and bookmarks files that require investigation. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={pha} className="system-image" alt="Decorative image related to PHA" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Program Health Assessment (PHA)`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`15`}</a></sup>{`: Program Health Assessment
is a system that reviews comma-separated values
files (CSVs) and application programming interfaces (APIs)
to aggregate raw data and flag possible metrics for
analysts. The collected data is used by analysts to inform
evaluations of investment risk, program success, and
product delivery. `}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={ccl} className="system-image" alt="Decorative image related to CCL" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Commerce Control List (CCL) (included as a non-AI system)`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`16`}</a></sup>{`: The
Commerce Control List lists goods and technology
items regulated by the U.S. government. Regulated items
are considered dual-use, meaning they are designed for
commercial purposes but have possible military
applications. Officials use the CCL to determine if technical
goods and data can be exported outside the United States.`}</p>
      </div>
    </div>
    <div className="system-container">
      <div className="system-image-container">
    <img src={thermal} className="system-image" alt="Decorative image related to Thermal" />
      </div>
      <div className="system-description">
        <p><strong parentName="p">{`Thermal (included as a non-AI system)`}</strong><sup style={{
            margin: "0px 2px"
          }}><a href="#image-credits-container">{`17`}</a></sup>{`: The
thermal imaging camera scans a person's body temperature from a distance
and provides live feed results to an agent. The agent uses the reported
temperature to decide whether to proceed with further screening or deny entry
of an individual to a public venue.`}</p>
      </div>
    </div>
    <div id="image-credits-container">
      <div style={{
        fontSize: "90%",
        fontWeight: "bold",
        marginBottom: "15px"
      }}>Image Credits</div>
      <div className="image-credits">
1. Service Depicted: Navy; Camera Operator: TIM MASTERSON - ID:DNST9304318 (dead link) Agency-Assigned Identifier: DNST9304318, Public Domain, https://commons.wikimedia.org/w/index.php?curid=1448384
      </div>
      <div className="image-credits">
2. Illustration by Michele Marconi
      </div>
      <div className="image-credits">
3. Image from Microsoft
      </div>
      <div className="image-credits">
4. Used with the permission of http://thenetwork.cisco.com/
      </div>
      <div className="image-credits">
5. Image from Jet Propulsion Laboratory
      </div>
      <div className="image-credits">
6. Image from International Airport Review
      </div>
      <div className="image-credits">
7. Handout—Getty Images
      </div>
      <div className="image-credits">
8. Image from PYMNTS
      </div>
      <div className="image-credits">
9. Image from CleanPNG
      </div>
      <div className="image-credits">
10. Image from MIT News
      </div>
      <div className="image-credits">
11. Image from New Electronics
      </div>
      <div className="image-credits">
12. Photo from Government CIO Media and Research
      </div>
      <div className="image-credits">
13. Image from Titan Tech
      </div>
      <div className="image-credits">
14. Image from Wired
      </div>
      <div className="image-credits">
15. Image from Atlassian
      </div>
      <div className="image-credits">
16. Image from University of North Texas
      </div>
      <div className="image-credits">
17. Image from Dhama Innovations Pvt. Ltd. via Wikimedia Commons, https://commons.wikimedia.org/wiki/File:Thermal_Image.jpg
      </div>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      